import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetSmsList: false,
  getSmsListMessage: '',
  getSmsListFailed: '',

  isLoadingGetSmsDraft: false,
  getSmsDraftMessage: '',
  getSmsDraftFailed: '',

  isLoadingPostSmsDraft: false,
  postSmsDraftMessage: '',
  postSmsDraftFailed: '',

  isLoadingPatchSmsDraft: false,
  patchSmsDraftMessage: '',
  patchSmsDraftFailed: '',

  isLoadingDeleteSmsDraft: false,
  deleteSmsDraftMessage: '',
  deleteSmsDraftFailed: '',

  isLoadingPostCopySmsDraft: false,
  postCopySmsDraftMessage: '',
  postCopySmsDraftFailed: '',

  isLoadingGetSmsPreview: false,
  getSmsPreviewMessage: '',
  getSmsPreviewFailed: '',
};

const initializeStates = JSON.parse(JSON.stringify(state));

function smsDraftReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initializeStates,
      };
    case actionTypes.GET_SMS_LIST_PENDING:
      return {
        ...globalState,
        isLoadingGetSmsList: true,
      };
    case actionTypes.GET_SMS_LIST_FULFILLED:
      return {
        ...globalState,
        isLoadingGetSmsList: false,
        getSmsListMessage: action.data,
        getSmsListFailed: '',
      };
    case actionTypes.GET_SMS_LIST_FAILURE:
      return {
        ...globalState,
        isLoadingGetSmsList: false,
        getSmsListMessage: '',
        getSmsListFailed: action.error,
      };
    case actionTypes.GET_SMS_DRAFT_PENDING:
      return {
        ...globalState,
        isLoadingGetSmsDraft: true,
      };
    case actionTypes.GET_SMS_DRAFT_FULFILLED:
      return {
        ...globalState,
        isLoadingGetSmsDraft: false,
        getSmsDraftMessage: action.data,
        getSmsDraftFailed: '',
      };
    case actionTypes.GET_SMS_DRAFT_FAILURE:
      return {
        ...globalState,
        isLoadingGetSmsDraft: false,
        getSmsDraftMessage: '',
        getSmsDraftFailed: action.error,
      };
    case actionTypes.POST_SMS_DRAFT_PENDING:
      return {
        ...globalState,
        isLoadingPostSmsDraft: true,
      };
    case actionTypes.POST_SMS_DRAFT_FULFILLED:
      return {
        ...globalState,
        isLoadingPostSmsDraft: false,
        postSmsDraftMessage: action.data,
        postSmsDraftFailed: '',
      };
    case actionTypes.POST_SMS_DRAFT_FAILURE:
      return {
        ...globalState,
        isLoadingPostSmsDraft: false,
        postSmsDraftMessage: '',
        postSmsDraftFailed: action.error,
      };
    case actionTypes.PATCH_SMS_DRAFT_PENDING:
      return {
        ...globalState,
        isLoadingPatchSmsDraft: true,
      };
    case actionTypes.PATCH_SMS_DRAFT_FULFILLED:
      return {
        ...globalState,
        isLoadingPatchSmsDraft: false,
        patchSmsDraftMessage: action.data,
        patchSmsDraftFailed: '',
      };
    case actionTypes.PATCH_SMS_DRAFT_FAILURE:
      return {
        ...globalState,
        isLoadingPatchSmsDraft: false,
        patchSmsDraftMessage: '',
        patchSmsDraftFailed: action.error,
      };
    case actionTypes.DELETE_SMS_DRAFT_PEDNING:
      return {
        ...globalState,
        isLoadingDeleteSmsDraft: true,
      };
    case actionTypes.DELETE_SMS_DRAFT_FULFILLED:
      return {
        ...globalState,
        isLoadingDeleteSmsDraft: false,
        deleteSmsDraftMessage: action.data,
        deleteSmsDraftFailed: '',
      };
    case actionTypes.DELETE_SMS_DRAFT_FAILURE:
      return {
        ...globalState,
        isLoadingDeleteSmsDraft: false,
        deleteSmsDraftMessage: '',
        deleteSmsDraftFailed: action.error,
      };
    case actionTypes.POST_COPY_SMS_DRAFT_PENDING:
      return {
        ...globalState,
        isLoadingPostCopySmsDraft: true,
      };
    case actionTypes.POST_COPY_SMS_DRAFT_FULFILLED:
      return {
        ...globalState,
        isLoadingPostCopySmsDraft: false,
        postCopySmsDraftMessage: action.data,
        postCopySmsDraftFailed: '',
      };
    case actionTypes.POST_COPY_SMS_DRAFT_FAILURE:
      return {
        ...globalState,
        isLoadingPostCopySmsDraft: false,
        postCopySmsDraftMessage: '',
        postCopySmsDraftFailed: action.error,
      };
    case actionTypes.GET_SMS_PREVIEW_PENDING:
      return {
        ...globalState,
        isLoadingGetSmsPreview: true,
      };
    case actionTypes.GET_SMS_PREVIEW_FULFILLED:
      return {
        ...globalState,
        isLoadingGetSmsPreview: false,
        getSmsPreviewMessage: action.data,
        getSmsPreviewFailed: '',
      };
    case actionTypes.GET_SMS_PREVIEW_FAILURE:
      return {
        ...globalState,
        isLoadingGetSmsPreview: false,
        getSmsPreviewMessage: '',
        getSmsPreviewFailed: action.error,
      };
    default:
      return {
        ...globalState,
      };
  }
}

export { smsDraftReducer as default };
